import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import _ from 'underscore';
import './boxLink.scss';
import {Helper} from '../../../Helpers';
import {File as FWFile} from '../../../FW/Models/File';

function iconBoxHoc(Component) {
  return class IconBoxHoc extends React.Component {
    constructor(props) {
      super(props);
      this.filesFetched = [];
      this.selectedTab = 0;
      let file =
        this.props.section.bp('background_file_id') &&
        this.props.section.bp('background_type') === 'image'
          ? FWFile.findOrCreate({
              id: this.props.section.bp('background_file_id')
            })
          : null;
      if (
        this.props.section.bp('background_file_id') &&
        file &&
        this.props.section.bp('background_type') === 'image'
      ) {
        file.fetch().then(() => {
          this.forceUpdate();
        });
      }
      this.state = {
        backgroundFile: file,
        hovered: false
      };
    }

    titleChanged = value => {
      this.props.section.prop('title', value);
    };

    subtitleChanged = value => {
      this.props.section.prop('subtitle', value);
    };

    mouseOver = () => {
      let toBeAnimated = $(
        '#animationContainer-' + this.props.section.get('id')
      ).find('.hoverAnimated');
      console.log(toBeAnimated);
      toBeAnimated.addClass(this.props.section.getAnimationClass('hover'));
      console.log(this.props.section.getAnimationClass('hover'));
      this.setState({
        hovered: true
      });
    };

    mouseLeave = () => {
      let toBeAnimated = $(
        '#animationContainer-' + this.props.section.get('id')
      ).find('.hoverAnimated');
      toBeAnimated.removeClass(this.props.section.getAnimationClass('hover'));
      this.setState({
        hovered: false
      });
    };

    componentDidMount() {
      const section = this.props.section;
      const scrollAnimation = section.getAnimationClass('scroll');
      if (scrollAnimation) {
        const toBeAnimated = $(`#animationContainer-${section.get('id')}`).find(
          '.scrollAnimated'
        );
        toBeAnimated.appear(() => {
          toBeAnimated.addClass(scrollAnimation);
          toBeAnimated.one(
            'webkitAnimationEnd oanimationend msAnimationEnd animationend',
            () => {
              toBeAnimated.removeClass(scrollAnimation);
            }
          );
        });
      }
    }

    fontFamilyChanged = fonts => {
      let extantFonts = this.props.section.prop('fonts') || [];
      extantFonts.forEach(font => {
        fonts.push(font);
      });
      let uniqueFamilies = [];
      $.each(fonts, function(i, el) {
        if ($.inArray(el, uniqueFamilies) === -1) uniqueFamilies.push(el);
      });
      uniqueFamilies.sort((a, b) => {
        return a > b;
      });
      if (uniqueFamilies.join(',') !== extantFonts.join(',')) {
        this.props.section.prop('fonts', uniqueFamilies);
        if (FW.store.get('page')) {
          FW.store.get('page').getFonts();
        }
      }
    };

    updateImage = () => {
      let file =
        this.props.section.bp('background_file_id') &&
        this.props.section.bp('background_type') === 'image'
          ? FWFile.findOrCreate({
              id: this.props.section.bp('background_file_id')
            })
          : null;
      if (
        this.props.section.bp('background_file_id') &&
        file &&
        this.props.section.bp('background_type') === 'image'
      ) {
        file.fetch().then(() => {
          this.forceUpdate();
        });
      }
      this.setState({
        backgroundFile: file
      });
    };

    componentDidMount() {
      this.props.section.on(
        'change',
        () => {
          this.forceUpdate();
        },
        this
      );
    }

    componentWillUnmount() {
      this.props.section.off(null, null, this);
    }

    getAnimationClass = target => {
      const section = this.props.section;
      const scrollTarget = section.getAnimation('scroll')
        ? section.getAnimation('scroll').target
        : '' || '';
      const hoverTarget = section.getAnimation('hover')
        ? section.getAnimation('hover').target
        : '' || '';
      const animateOnHover = ' ' + 'hoverAnimated';
      const animateOnScroll = ' ' + 'scrollAnimated';
      return (
        (hoverTarget === target ? animateOnHover : '') +
        ' ' +
        (scrollTarget === target ? animateOnScroll : '')
      );
    };

    render() {
      const section = this.props.section;
      let props = _.clone(this.props);
      props.filesFetched = this.filesFetched;
      props.fontFamilyChanged = this.fontFamilyChanged;

      const options = section.prop('options');

      const iconHoverStyle = {
        color: options.iconHoverColor,
        background: options.iconBackgroundHoverColor
      };

      const iconStyle = {
        color: options.iconColor,
        background: options.iconBackgroundColor
      };

      const padding = this.props.section.ls('padding');

      const boxStyle = {
        color: options.textColor,
        paddingLeft: typeof padding !== 'undefined' ? padding : 6,
        paddingRight: typeof padding !== 'undefined' ? padding : 6,
        paddingBottom: typeof padding !== 'undefined' ? padding : 6
      };

      return (
        <div
          id={'animationContainer-' + this.props.section.get('id')}
          className={this.props.section.getAnimationClass('load')}
          onMouseOver={this.mouseOver}
          onMouseLeave={this.mouseLeave}
        >
          <Component
            getAnimationClass={this.getAnimationClass}
            fontFamilyChanged={this.fontFamilyChanged}
            titleChanged={this.titleChanged}
            subtitleChanged={this.subtitleChanged}
            inlineEditorProps={{enter: 2}}
            hoverTarget={this.props.section.getAnimationTarget('hover')}
            animateOnHover={' hoverAnimated '}
            backgroundFile={this.state.backgroundFile}
            updateImage={this.updateImage}
            iconHoverStyle={iconHoverStyle}
            iconStyle={iconStyle}
            boxStyle={boxStyle}
            isHovered={this.state.hovered}
            {...props}
          />
        </div>
      );
    }
  };
}

class IconBox extends React.Component {
  render() {
    const section = this.props.section;

    const bkgFile = this.props.backgroundFile;
    if (section.bp('background_type') === 'image') {
      if (
        (bkgFile && section.bp('background_file_id') !== bkgFile.get('id')) ||
        (!bkgFile && section.bp('background_file_id'))
      ) {
        this.props.updateImage();
      }
    }

    const padding = section.ls('padding') + 'px' || '0px';
    const backgroundCSS = section.getBackgroundCss();
    const shadowCSS = section.ls('text-shadow')
      ? section.ls('text-shadow').shadow_css
      : '';
    const fileUrl =
      bkgFile && bkgFile.helper && section.bp('background_type') === 'image'
        ? bkgFile.helper.thumbnailUrl('optimized')
        : null;

    const link = section.prop('link');
    const linkHref = typeof link.href !== 'undefined' ? link.href : link;
    const border = section.ls('border') || {};

    const box = (
      <div style={this.props.boxStyle}>
        <i
          style={
            this.props.isHovered
              ? this.props.iconHoverStyle
              : this.props.iconStyle
          }
          className={'fa ' + section.prop('icon') + ' iconBoxIcon'}
          aria-hidden="true"
        />
        <div
          className={'iconBoxContainer'}
          style={{
            textShadow: shadowCSS
          }}
        >
          {fileUrl ? (
            <div
              className={
                section.bp('parallax') ? 'fw-parallax' : 'fw-noParallax'
              }
              style={{
                backgroundSize: section.bp('background_size'),
                backgroundRepeat: 'no-repeat',
                backgroundImage: 'url("' + fileUrl + '")',
                zIndex: -1000,
                borderRadius: border.borderRadius,
                borderStyle: 'solid',
                border: border.border
              }}
            />
          ) : null}
          <div
            style={{
              background: section.ls('background') ? backgroundCSS : '#FFF',
              opacity: section.ls('background')
                ? section.getBackgroundOpacity()
                : 1,
              zIndex: -100,
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: border ? border.borderRadius : '6px',
              borderStyle: 'solid',
              border: border ? border.border : '0px black'
            }}
          />
          <InlineEditableElement
            html={section.prop('title')}
            el={'h3'}
            {...this.props.inlineEditorProps}
            onChange={this.props.titleChanged}
            fontFamilyChanged={this.props.fontFamilyChanged}
            inlineEditingEnabled={this.props.inlineEditingEnabled}
          />
          <div className="iconBoxContent">
            <InlineEditableElement
              html={section.prop('subtitle')}
              {...this.props.inlineEditorProps}
              onChange={this.props.subtitleChanged}
              fontFamilyChanged={this.props.fontFamilyChanged}
              inlineEditingEnabled={this.props.inlineEditingEnabled}
            />
          </div>
        </div>
      </div>
    );

    return (
      <div className={'hoverAnimated'}>
        <div style={{height: 20}} />
        <div
          id={`iconBox-${section.get('id')}`}
          className={'iconBoxSection ' + section.getAnimationClass('load')}
        >
          {!FW.inEditor() && linkHref ? (
            <a
              className="iconBoxLink"
              href={Helper.fixHref(linkHref)}
              target={section.prop('target') || '_self'}
              aria-label={section.prop('ada_title')}
            >
              {box}
            </a>
          ) : (
            box
          )}
        </div>
      </div>
    );
  }
}

export {iconBoxHoc as hoc};
export default iconBoxHoc(IconBox);
